var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',{staticStyle:{"min-width":"100px"}},[_c('b-col',[_c('v-select',{attrs:{"options":_vm.ANADEPOOPTION,"label":"DESCRIPTION","autocomplete":"","size":"small","menu-props":{ top: true, offsetY: true }},on:{"input":_vm.setSecilen},model:{value:(_vm.DEPOID),callback:function ($$v) {_vm.DEPOID=$$v},expression:"DEPOID"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }